import { useLocation } from 'umi';

type IReturn = {
  personalAccident: boolean;
  personalAccidentOptions: boolean;
  business: boolean;
  numberOfSeas: boolean;
  tonnage: boolean;
  physicalDamage: boolean;
  phsicalDamageRequired: boolean;
};

type IParams = {
  vehicleType?: string;
  pa?: boolean;
  coverageType?: string;
};

function useVehicleFiledsVisiblity({
  vehicleType = '',
  pa = false,
  coverageType = '',
}: IParams): IReturn {
  const location: any = useLocation();
  let { totalStep } = location.query;
  totalStep = Number(totalStep);

  const businessUsageVisible = ['Passenger Transportation', 'Pick-up'].includes(
    vehicleType,
  );
  const tonnageVisible = [
    'Truck',
    'Special purpose vehicle with required load carrying capacity',
  ].includes(vehicleType);

  const personalAccidentVisible =
    [
      'Business use purpose',
      'None business use purpose',
      'Truck',
      'Trailer',
      'Taxi',
      'Special purpose vehicle with required load carrying capacity',
      'Special purpose vehicle without required load carrying capacity',
      'Pickup minivan',
      'None business Pickup minivan',
      'Armored car',
      'Ambulance',
      'Special Vehicle',
      'Passenger Transportation',
      'Pick-up',
      '2 Wheeler <= 50CC',
      '2 Wheeler > 50CC',
      '3Wheeler',
      'Electric Motorcycle',
    ].includes(vehicleType) &&
    (coverageType === 'tpl' || totalStep === 3);

  const personalAccidentOptionsVisible =
    [
      'Business use purpose',
      'None business use purpose',
      'Truck',
      'Trailer',
      'Taxi',
      'Special purpose vehicle with required load carrying capacity',
      'Special purpose vehicle without required load carrying capacity',
      'Pickup minivan',
      'None business Pickup minivan',
      'Armored car',
      'Ambulance',
      'Special Vehicle',
    ].includes(vehicleType) &&
    (coverageType === 'tpl' || totalStep === 3) &&
    pa;

  const numberOfSeasVisible = [
    'Business use purpose',
    'None business use purpose',
    'Truck',
    'Trailer',
    'Taxi',
    'Special purpose vehicle with required load carrying capacity',
    'Special purpose vehicle without required load carrying capacity',
    'Pickup minivan',
    'None business Pickup minivan',
    'Armored car',
    'Ambulance',
    'Special Vehicle',
    'Passenger Transportation',
    'Pick-up',
  ].includes(vehicleType);

  const physicalDamageVisible =
    totalStep === 3
      ? ['Passenger Transportation', 'Pick-up'].includes(vehicleType)
      : totalStep === 2 && 'cpd' === coverageType;

  const phsicalDamageRequired = totalStep === 2 && 'cpd' === coverageType;

  return {
    personalAccident: personalAccidentVisible,
    personalAccidentOptions: personalAccidentOptionsVisible,
    business: businessUsageVisible,
    numberOfSeas: numberOfSeasVisible,
    tonnage: tonnageVisible,
    physicalDamage: physicalDamageVisible,
    phsicalDamageRequired,
  };
}

export default useVehicleFiledsVisiblity;
